import './validator/initialisation';

export function getRecaptcha() {
    const captchaElement = document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]');

    if (!captchaElement) {
        return null;
    }

	let url = new URL(captchaElement.src);
	let params = new URLSearchParams(url.search);
	return grecaptcha.execute(params.get('render'));
};

$.fn.ajaxInvalidFeedback = function(options) {
	return this.each(function() {
		let object = $(this).data('ajaxInvalidFeedback');
		if (typeof options == 'object') {
			$(this).addClass('has-invalid-feedback-ajax').after(`
				<div class='invalid-feedback invalid-feedback-ajax d-block'>${options.error}</div>
			`);
			let destroyHandler = () => $(this).ajaxInvalidFeedback('destroy');
			$(this).on('change input', destroyHandler);
			$(this.form).on('submit', destroyHandler);
			$(this).data('ajaxInvalidFeedback', {destroyHandler});
		} else if (options === 'destroy') {
			$(this).off('change input', object.destroyHandler).removeClass('has-invalid-feedback-ajax').siblings('.invalid-feedback-ajax').remove();
			$(this.form).off('submit', object.destroyHandler);
			$(this).data('ajaxInvalidFeedback', null);
		}
	});
};

$.fn.toggleValid = function (valid) {
    this.each((i, element) => element.setCustomValidity(valid ? "" : 'invalid'));
};

export function processFormErrors(errors, form) {
	for (let fieldName in errors) {
		if (fieldName == form.name) {
			for (let error of errors[fieldName]) {
				alert(error);
			}
		} else {
			let error = errors[fieldName].join('<br>');
			if (fieldName + '[]' in form.elements) {
				$(form.elements[fieldName + '[]']).ajaxInvalidFeedback({error: error});
			} else {
				$(form.elements[fieldName]).ajaxInvalidFeedback({error: error});
			}
		}
	}
};

export async function setRecaptchaResponse(form) {
    if ($(form).data('recaptcha') && !$(form.elements).filter('.g-recaptcha-response').length) {
		let fieldName = typeof $(form).data('recaptcha') == 'string' ? $(form).data('recaptcha') : 'g-recaptcha-response';
        $(form).append(`<input type="hidden" name="${fieldName}" class="g-recaptcha-response">`);
    }
    if ($(form.elements).filter('.g-recaptcha-response').length) {
        $(form.elements).filter('.g-recaptcha-response').val(await getRecaptcha());
    }
};

$('.ajax-form').on('submit', async function(event) {
	event.preventDefault();
	$(this.elements).filter('[type=submit]').prop('disabled', true);
	await setRecaptchaResponse(this);

	try {
		var data = await $.ajax({
			type: 'post',
			url: this.action,
			data: new FormData(this),
			processData: false,
			contentType: false,
		});
	} catch (xhr) {
		let errorEvent = $.Event('submit-error');
		$(this).trigger(errorEvent, xhr);
		if (!errorEvent.isDefaultPrevented()) {
			if (xhr.responseJSON && xhr.responseJSON.errors) {
				processFormErrors(xhr.responseJSON.errors, this);
			} else {
				alert("Wystąpił nieznany błąd, spróbuj ponownie później.");
			}
		}
		$('html, body').animate({
			scrollTop: $(this).offset().top - 96
		}, 0);
		return;
	} finally {
		$(this.elements).filter('[type=submit]').prop('disabled', false);
	}
	let successEvent = $.Event('submit-success');
	$(this).trigger(successEvent, data);
	if (!successEvent.isDefaultPrevented()) {
		this.reset();
		$(this).removeClass('was-validated');
		$(this).find('.has-invalid-feedback-ajax').ajaxInvalidFeedback('destroy');
		$(this).find('.is-valid').removeClass('is-valid');
		$(this).find('.is-invalid').removeClass('is-invalid');
		$(this).find('.form-file .btn-remove').hide();
		$(this).find('.dropdown-select').each(function() {
			this.querySelector('.btn-select').innerHTML = this.querySelector('.dropdown-menu .dropdown-item:first-child').innerHTML;
			this.querySelector('input').value = this.querySelector('.dropdown-menu .dropdown-item:first-child').dataset.value;
		});
		$(this).find('img[data-src]').each(function() {
			$(this).attr('src', $(this).data('src'));
		});

		$(this).find('input, textarea').each(function() {
			// Fix IMask not updating value on form reset
			this.dispatchEvent(new Event('input', { bubbles: true }));
		});
	};
});

// Handle custom file input UI
document.querySelectorAll('.file-input-wrapper').forEach(wrapper => {
	const fileInput = wrapper.parentElement.querySelector('input[type="file"]');
	const fileNamesList = wrapper.querySelector('.file-names-list');
	const button = wrapper.querySelector('.button');

	let filesArray = [];

	// Click triggers file input
	wrapper.addEventListener('click', () => fileInput.click());
	if (button) button.addEventListener('click', e => {
		e.stopPropagation();
		fileInput.click();
	});

	// Render file names list
	function renderFileNames() {
		fileNamesList.innerHTML = '';
		if (filesArray.length === 0) {
			// fileNamesList.textContent = '(opcjonalnie)';
			return;
		}
		filesArray.forEach((file, idx) => {
			const fileItem = document.createElement('div');
			fileItem.className = 'file-name-item';

			const nameSpan = document.createElement('span');
			nameSpan.className = 'file-name';
			nameSpan.textContent = file.name;
			fileItem.appendChild(nameSpan);

			const removeBtn = document.createElement('span');
			removeBtn.className = 'remove-file';
			removeBtn.innerHTML = '&#10006;';
			removeBtn.addEventListener('click', e => {
				e.stopPropagation();
				filesArray.splice(idx, 1);
				updateFileInput();
				renderFileNames();
			});

			fileItem.appendChild(removeBtn);
			fileNamesList.appendChild(fileItem);
		});
	}

	// Update file input files
	function updateFileInput() {
		const dt = new DataTransfer();
		filesArray.forEach(f => dt.items.add(f));
		fileInput.files = dt.files;
	}

	// On file select
	fileInput.addEventListener('change', () => {
		const newFiles = Array.from(fileInput.files).filter(f => f.name && f.size > 0); // <-- filter out empty files
		newFiles.forEach(newFile => {
			if (!filesArray.some(f => f.name === newFile.name && f.size === newFile.size)) {
				filesArray.push(newFile);
			}
		});
		fileInput.value = '';
		updateFileInput();
		renderFileNames();
	});

	// On form reset
	fileInput.form?.addEventListener('reset', () => {
		filesArray = [];
		renderFileNames();
	});

	// Initial render
	renderFileNames();
});


// orderId required logic based on subject
(function () {
    const subjectInput = document.getElementById('subject');
    const orderIdInput = document.getElementById('orderId');

    if (!subjectInput || !orderIdInput) return;

    const REQUIRES_ORDER_ID = /reklamacja|anulacja/i;

    function updateOrderIdRequired() {
        const value = subjectInput.value;
        const isRequired = REQUIRES_ORDER_ID.test(value);

        orderIdInput.required = isRequired;
        orderIdInput.placeholder = isRequired
            ? 'ID Zamówienia'
            : 'ID Zamówienia (opcjonalnie)';
        orderIdInput.setAttribute('aria-required', String(isRequired));
    }

    subjectInput.addEventListener('change', updateOrderIdRequired);
    updateOrderIdRequired(); // run on init in case subject is pre-filled
})()